import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { currentStateList } from "../../../../../constants/state";
import { PopupStateless } from "../../../../Popup";
import { RenderAbbreviatedPopup, RenderFail, RenderLoader, RenderPopup, RenderSuccess } from "./components";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var RenderPopupFormsOld = /*#__PURE__*/memo(function (_ref) {
  var renderPopup = _ref.renderPopup,
    closePopup = _ref.closePopup,
    isOpen = _ref.isOpen,
    data = _ref.data;
  return /*#__PURE__*/React.createElement(PopupStateless, {
    className: cx('popup'),
    onClose: closePopup,
    opened: isOpen,
    "data-t-id": "components-Old"
  }, renderPopup === currentStateList.abbreviated && /*#__PURE__*/React.createElement(RenderAbbreviatedPopup, {
    data: data
  }), renderPopup === currentStateList.none && /*#__PURE__*/React.createElement(RenderPopup, {
    data: data
  }), renderPopup === currentStateList.success && /*#__PURE__*/React.createElement(RenderSuccess, {
    texts: data.texts
  }), renderPopup === currentStateList.fail && /*#__PURE__*/React.createElement(RenderFail, {
    texts: data.texts
  }), renderPopup === currentStateList.loading && /*#__PURE__*/React.createElement(RenderLoader, null));
});
RenderPopupFormsOld.propTypes = {
  data: PropTypes.shape({}),
  renderPopup: PropTypes.string,
  isOpen: PropTypes.bool,
  closePopup: PropTypes.func
};